import React from "react";
import {
  Row,
  Col,
  Container,
  Button,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  Spinner,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink
} from "reactstrap";

import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

//Services
import TeachingLevelService from '../../services/TeachingLevelService';
import SchoolWorkService from '../../services/SchoolWorkService';
import SchoolService from '../../services/SchoolService';

class ShowUploadFiles extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      firstIn: true,
      schools: [],
      recordsPerPage: 20,
      activePage: 1,
      total: 0,
      searchResults: [],
      isSearching: false,
      levels: [],
      school: null,
      level: null,
      grade: null,
      theme: null,
      competence: null
    };

    this.teachingLevelService = new TeachingLevelService();
    this.schoolWorkService = new SchoolWorkService();
    this.schoolService = new SchoolService();


    this.handleGetTeachingLevels = this.handleGetTeachingLevels.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.numberOfPages = this.numberOfPages.bind(this);
    this.setPage = this.setPage.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.lastPage = this.lastPage.bind(this);
    this.firstPage = this.firstPage.bind(this);
    this.handleSchoolSearch = this.handleSchoolSearch.bind(this);
    this.handleSelectedSchool = this.handleSelectedSchool.bind(this);
  }

  async handleGetTeachingLevels() {
    const levels = await this.teachingLevelService.get();
    this.setState({ levels: levels.data.levels });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  async handleSchoolSearch(query) {
    this.setState({ isLoading: true });
    const response = await this.schoolService.search({ name: query });
    this.setState({ schools: response.data.schools, isLoading: false });
  }

  handleSelectedSchool(selected) {
      this.setState({
        school: selected.length > 0 ? selected[0] : null
      });
  }

  async handleSearch(event, page = 1) {
    this.setState({ isSearching: true, searchResults: [] });
    const { school, level, grade, theme, competence } = this.state;
    const result = await this.schoolWorkService.search({
      school: school != null && !!school.id ? school.id : null,
      level: level,
      grade: grade,
      theme: theme,
      competence: competence,
      recordsPerPage: this.state.recordsPerPage,
      page: page
    });
    this.setState({
      firstIn: false,
      activePage: page,
      isSearching: false,
      searchResults: !result.data.error ? result.data.results : [],
      total: !result.data.error ? result.data.total : 0,
      pages: this.numberOfPages(!result.data.error ? result.data.total : 0)
    });
  }

  numberOfPages(total) {
    return Math.ceil(total / this.state.recordsPerPage);
  }

  async setPage(event) {
    await this.setState({ activePage: parseInt(event.target.textContent) });
    await this.handleSearch(null, this.state.activePage);
  }

  async nextPage() {
    const next = (this.state.activePage + 1);
    if (next <= this.state.pages) {
      await this.setState({ activePage: next });
      await this.handleSearch(null, next);
    }
  }

  async previousPage() {
    const previous = (this.state.activePage - 1);
    if (this.state.pages >= previous && previous !== 0) {
      await this.setState({ activePage: previous });
      await this.handleSearch(null, previous);
    }
  }

  async lastPage() {
    await this.setState({ activePage: this.state.pages });
    await this.handleSearch(null, this.state.pages);
  }

  async firstPage() {
    await this.setState({ activePage: 1 });
    await this.handleSearch(null, 1);
  }

  async componentDidMount() {
    await this.handleGetTeachingLevels();
  }

  render() {
    return (
      <div className="pt-5 pb-5 bg-light">
        <Row>
          <Container>
            <Col>
              <div className="font36"> Pesquise os trabalhos publicados </div>
              <h5> Selecione as opções abaixo para ver os resultados desejados </h5>
            </Col>
            <Row>
              <Col xs="12" sm="12" md="12" lg="12" xl="12">
                <FormGroup className="p-2">
                  <Label for="school">Escola</Label>
                  <AsyncTypeahead
                    id="school"
                    labelKey="name"
                    emptyLabel="Nenhuma escola encontrada"
                    promptText="Digite para pesquisar"
                    searchText="Buscando escolas..."
                    size="small"
                    useCache={false}
                    isLoading={this.state.isLoading}
                    minLength={3}
                    onSearch={this.handleSchoolSearch}
                    options={this.state.schools}
                    onChange={this.handleSelectedSchool}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="12" md="6" lg="6" xl="6">
                <FormGroup className="p-2">
                  <Label for="level">Nível de ensino</Label>
                  <Input
                    type="select"
                    name="level"
                    id="level"
                    onChange={this.handleChange}
                    bsSize="sm"
                    defaultValue="">
                    <option value="">Selecione</option>
                    {this.state.levels.map((ele) => {
                      return (
                        <option key={ele.id} value={ele.id}>{ele.level}</option>
                      )
                    })}
                  </Input>
                </FormGroup>
              </Col>
              <Col xs="12" sm="12" md="6" lg="6" xl="6">
                <FormGroup className="p-2">
                  <Label for="grade">Série</Label>
                  <Input
                    type="select"
                    name="grade"
                    id="grade"
                    onChange={this.handleChange}
                    bsSize="sm"
                    defaultValue="">
                    <option value="">Selecione</option>
                    <option value='1'>1º</option>
                    <option value='2'>2º</option>
                    <option value='3'>3º</option>
                    <option value='4'>4º</option>
                    <option value='5'>5º</option>
                    <option value='6'>6º</option>
                    <option value='7'>7º</option>
                    <option value='8'>8º</option>
                    <option value='9'>9º</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col xs="12" sm="12" md="6" lg="6" xl="6">
                <FormGroup className="p-2">
                  <Label for="competence">Competência</Label>
                  <Input
                    onChange={this.handleChange}
                    type="select"
                    name="competence"
                    id="competence"
                    bsSize="sm"
                    defaultValue="">
                    <option value="">Selecione</option>
                    <option value='LIT'>LIT - Linguagens e suas tecnologias</option>
                    <option value='MTT'>MTT - Matemática e suas tecnologias</option>
                    <option value='CNT'>CNT - Ciência da natureza e suas tecnologias</option>
                    <option value='CHSA'>CHSA - Ciências humanas e sociais aplicadas</option>
                    <option value='FTP'>FTP - Formação técnica profissional</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col xs="12" sm="12" md="6" lg="6" xl="6">
                <div className="p-2">
                  <Label for="selectCompetencia">Tema aplicado</Label>
                  <InputGroup size="sm">
                    <Input
                      id='theme'
                      name='theme'
                      onChange={this.handleChange}
                      placeholder="Nome do tema" />
                    <InputGroupAddon addonType="prepend">
                      <Button onClick={this.handleSearch} color="dark">
                        <FontAwesomeIcon icon={faSearch} size="lg" />
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                </div>
              </Col>
            </Row>
            {this.state.isSearching &&
              <Row>
                <Spinner style={{ marginLeft: 'auto', marginRight: 'auto' }} animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </Row>}

            {(!this.state.firstIn
              && this.state.searchResults.length === 0
              && !this.state.isSearching)
              && <Col>  <h5>Nenhum resultado encontrado.</h5></Col>}

            {this.state.searchResults.length > 0 &&
              <Row>
                <Col className="m-2">
                  <div className="font36 ml-2"> Resultados. </div>
                  <Col><h5>Página {this.state.activePage} de {this.state.total} resultados.</h5></Col>
                  <Table hover>
                    <thead>
                      <tr>
                        <th>Escola</th>
                        <th>Série</th>
                        <th>Competência</th>
                        <th>Título</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.searchResults.map((item) => {
                        return (
                          <tr>
                            <th scope="row">{item.name}</th>
                            <td>{item.grade}</td>
                            <td>{item.competence}</td>
                            <td>{item.theme}</td>
                          </tr>
                        )
                      })}

                    </tbody>
                  </Table>

                  <Pagination aria-label="Page navigation example">
                    <PaginationItem style={{ border: 'none' }}>
                      <PaginationLink first onClick={this.firstPage} />
                    </PaginationItem>
                    <PaginationItem style={{ border: 'none' }}>
                      <PaginationLink previous onClick={this.previousPage} />
                    </PaginationItem>
                    {[...Array(this.state.pages).keys()].map((i) => {
                      i = ++i;
                      return (
                        <PaginationItem active={this.state.activePage === i} style={{ border: 'none' }}>
                          <PaginationLink target={i} onClick={this.setPage}>{i}</PaginationLink>
                        </PaginationItem>
                      )
                    })}
                    <PaginationItem style={{ border: 'none' }}>
                      <PaginationLink next onClick={this.nextPage} />
                    </PaginationItem>
                    <PaginationItem style={{ border: 'none' }}>
                      <PaginationLink last onClick={this.lastPage} />
                    </PaginationItem>
                  </Pagination>
                </Col>
              </Row>
            }
          </Container>
        </Row>
      </div>
    );
  }
}

export default ShowUploadFiles;
